




















import Component, {mixins} from "vue-class-component";
import Vue from "vue";
import {Project, ProjectMetaData} from "../model/interface/project.interface";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {Prop, Watch} from "vue-property-decorator";
import {Observer} from "../model/interface/subject-observer.interface";
import ProjectHandleComponent from "./project-handle.vue";
import {Author} from "../model/interface/author";
import {WhitelistService} from "../services/whitelist.service";

@Component({
  components: {ProjectHandleComponent}
})
export default class ProjectEditComponent extends Vue implements Observer {
  @Prop(Object) projectMeta!: ProjectMetaData;
  @Prop(Number) activateDialog!: number;

  private validate: number = 0;
  private showDialog: boolean = false;
  private loading:boolean = false;

  private project: Project = null;

  async mounted() {
    this.showDialog = true;
    await this.loadProject(this.projectMeta.id);
  }

  private async loadProject(projectId: number) {
    //API request to get Whitelist
    try {
      const project: Project | false = await ProjectService.getProject(projectId)
      if(!project) {
        MessageBus.$emit(AlertType[AlertType.error], 'Error during Project fetch!');
        return;
      }
      this.project = project;
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Project update! ' + e);
    } finally {
      this.loading = false;
    }
  }

  private submitProject() {
    this.validate++;
  }

  async update(isValidated: boolean) {
    if (!isValidated)
      return;
    try {
      const status = await ProjectService.putProject(this.project);
      if(status === 202) {
        window.location.reload();
      }
    } catch(e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Project update! ' + e);
    }
    this.showDialog = false;
  }

  @Watch("activateDialog")
  private async onDialogChange(activateDialog: number) {
    this.showDialog = true;
    await this.loadProject(this.projectMeta.id);
  }
}
